import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { toUrl } from '../lib/config';

const SosyalHizmetBirimiPage: React.FC = () => {
  const [formData, setFormData] = useState({
    adiSoyadi: '',
    tcKimlikNo: '',
    anneAdi: '',
    babaAdi: '',
    dogumYeri: '',
    dogumTarihi: '',
    tedaviGorduguBirim: '',
    basvuruTarihi: '',
    yasTarihi: '',
    protokolNo: '',
    saglikGuvencesi: '',
    telefonNo: '',
    adres: '',
    gorusmeninYapildigiYer: '',
    gorusdenKisi: '',
    sosyalHizmetBirimine: '',
    hastanınSaglikVeFizikseli: '',
    hastanınPsiko: '',
    hastanınBarinma: '',
    degerlendirme: '',
    sonucVeOneriler: '',
    gorusmeTarihi: '',
    gorusmeYapan: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError('');
      setSuccess(false);

      const url = toUrl('/api/sosyal-hizmet-birimi');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Form gönderilemedi. Lütfen tekrar deneyin.');
      }

      setSuccess(true);
      setFormData({
        adiSoyadi: '',
        tcKimlikNo: '',
        anneAdi: '',
        babaAdi: '',
        dogumYeri: '',
        dogumTarihi: '',
        tedaviGorduguBirim: '',
        basvuruTarihi: '',
        yasTarihi: '',
        protokolNo: '',
        saglikGuvencesi: '',
        telefonNo: '',
        adres: '',
        gorusmeninYapildigiYer: '',
        gorusdenKisi: '',
        sosyalHizmetBirimine: '',
        hastanınSaglikVeFizikseli: '',
        hastanınPsiko: '',
        hastanınBarinma: '',
        degerlendirme: '',
        sonucVeOneriler: '',
        gorusmeTarihi: '',
        gorusmeYapan: ''
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    
    // TC Kimlik No için sadece rakam kontrolü
    if (name === 'tcKimlikNo') {
      if (value && !/^\d*$/.test(value)) {
        return; // Harf veya özel karakter varsa güncelleme
      }
    }
    
    // Telefon No için sadece rakam ve 0 ile başlama kontrolü
    if (name === 'telefonNo') {
      if (value && !/^\d*$/.test(value)) {
        return; // Harf veya özel karakter varsa güncelleme
      }
      // İlk karakter 0 olmalı
      if (value.length > 0 && value[0] !== '0') {
        return; // 0 ile başlamıyorsa güncelleme
      }
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="anket-page">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h6 className="text-muted mb-2">Bize ulaşın</h6>
          <h1 className="mb-3">
            İletişim
          </h1>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            margin: '0 auto 20px' 
          }}></div>
          <p className="text-muted mb-3" style={{ maxWidth: '600px', margin: '0 auto 15px' }}>
            Megapark Hastanesi her an ve her zaman sizin yanınızda
          </p>
          <div style={{ 
            width: '100%', 
            height: '1px', 
            backgroundColor: '#ddd', 
            margin: '0' 
          }}></div>
        </div>

        <div className="mt-5">
          <h4 className="mb-2 fw-bold">Sosyal Hizmet Birimi Hasta Görüşme</h4>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            marginBottom: '30px' 
          }}></div>

          {/* Başarı Mesajı */}
          {success && (
            <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
              <Alert.Heading>Teşekkür Ederiz!</Alert.Heading>
              <p>
                Hasta görüşme formu başarıyla gönderildi. Kayıt sisteme eklendi.
              </p>
            </Alert>
          )}

          {/* Hata Mesajı */}
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              <Alert.Heading>Hata!</Alert.Heading>
              <p>{error}</p>
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="survey-form">
            {/* Adı Soyadı */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Adı Soyadı
              </Form.Label>
              <Form.Control
                type="text"
                name="adiSoyadi"
                value={formData.adiSoyadi}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* TC Kimlik No */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                TC Kimlik No
              </Form.Label>
              <Form.Control
                type="text"
                name="tcKimlikNo"
                value={formData.tcKimlikNo}
                onChange={handleChange}
                placeholder=""
                maxLength={11}
                pattern="[0-9]*"
                inputMode="numeric"
                className="form-control-lg"
                style={{ 
                  backgroundColor: '#f5f5f5',
                  maxWidth: '200px'
                }}
              />
            </Form.Group>

            {/* Anne-Baba Adı */}
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Anne-Baba Adı
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="anneAdi"
                    value={formData.anneAdi}
                    onChange={handleChange}
                    placeholder="Anne Adı..."
                    className="form-control-lg"
                    style={{ backgroundColor: '#f5f5f5' }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={{ visibility: 'hidden' }}>
                    Baba Adı
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="babaAdi"
                    value={formData.babaAdi}
                    onChange={handleChange}
                    placeholder="Baba Adı..."
                    className="form-control-lg"
                    style={{ backgroundColor: '#f5f5f5' }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Doğum Yeri ve Tarihi */}
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Doğum Yeri ve Tarihi
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="dogumYeri"
                    value={formData.dogumYeri}
                    onChange={handleChange}
                    placeholder="Doğum Yeri"
                    className="form-control-lg"
                    style={{ backgroundColor: '#f5f5f5' }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={{ visibility: 'hidden' }}>
                    Doğum Tarihi
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="dogumTarihi"
                    value={formData.dogumTarihi}
                    onChange={handleChange}
                    placeholder="gg.aa.yyyy"
                    className="form-control-lg"
                    style={{ backgroundColor: '#f5f5f5' }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Tedavi Gördüğü Birim */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Tedavi Gördüğü Birim
              </Form.Label>
              <Form.Control
                type="text"
                name="tedaviGorduguBirim"
                value={formData.tedaviGorduguBirim}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Başvuru Tarihi */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Başvuru Tarihi
              </Form.Label>
              <Form.Control
                type="date"
                name="basvuruTarihi"
                value={formData.basvuruTarihi}
                onChange={handleChange}
                placeholder="gg.aa.yyyy"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Yaş Tarihi */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Yaş Tarihi
              </Form.Label>
              <Form.Control
                type="date"
                name="yasTarihi"
                value={formData.yasTarihi}
                onChange={handleChange}
                placeholder="gg.aa.yyyy"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Protokol No */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Protokol No
              </Form.Label>
              <Form.Control
                type="text"
                name="protokolNo"
                value={formData.protokolNo}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ 
                  backgroundColor: '#f5f5f5',
                  maxWidth: '250px'
                }}
              />
            </Form.Group>

            {/* Sağlık Güvencesi */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Sağlık Güvencesi
              </Form.Label>
              <Form.Control
                type="text"
                name="saglikGuvencesi"
                value={formData.saglikGuvencesi}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Telefon No */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Telefon No
              </Form.Label>
              <Form.Control
                type="text"
                name="telefonNo"
                value={formData.telefonNo}
                onChange={handleChange}
                placeholder="05XX XXX XX XX"
                maxLength={11}
                pattern="[0-9]*"
                inputMode="numeric"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Adres */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Adres
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="adres"
                value={formData.adres}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Görüşmenin Yapıldığı Yer */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Görüşmenin Yapıldığı Yer
              </Form.Label>
              <Form.Control
                type="text"
                name="gorusmeninYapildigiYer"
                value={formData.gorusmeninYapildigiYer}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Görüşülen Kişi */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Görüşülen Kişi
              </Form.Label>
              <Form.Control
                type="text"
                name="gorusdenKisi"
                value={formData.gorusdenKisi}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Sosyal Hizmet Birimine Başvuru/Havale/Görüşme Nedeni */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Sosyal Hizmet Birimine Başvuru/Havale/Görüşme Nedeni
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="sosyalHizmetBirimine"
                value={formData.sosyalHizmetBirimine}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Hastanın Sağlık ve Fizikseli Durumu */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Hastanın Sağlık ve Fizikseli Durumu
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="hastanınSaglikVeFizikseli"
                value={formData.hastanınSaglikVeFizikseli}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Hastanın Psiko-Sosyal ve Ailevi Durumu */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Hastanın Psiko-Sosyal ve Ailevi Durumu
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="hastanınPsiko"
                value={formData.hastanınPsiko}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Hastanın Barınma ve Ekonomik Durumu */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Hastanın Barınma ve Ekonomik Durumu
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="hastanınBarinma"
                value={formData.hastanınBarinma}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Değerlendirme */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Değerlendirme
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="degerlendirme"
                value={formData.degerlendirme}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Sonuç ve Öneriler */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Sonuç ve Öneriler
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="sonucVeOneriler"
                value={formData.sonucVeOneriler}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Görüşme Tarihi */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Görüşme Tarihi
              </Form.Label>
              <Form.Control
                type="date"
                name="gorusmeTarihi"
                value={formData.gorusmeTarihi}
                onChange={handleChange}
                placeholder="gg.aa.yyyy"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Görüşmeyi Yapan */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Görüşmeyi Yapan
              </Form.Label>
              <Form.Control
                type="text"
                name="gorusmeYapan"
                value={formData.gorusmeYapan}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
              />
            </Form.Group>

            {/* Submit Button */}
            <div className="text-center mt-4">
              <Button
                type="button"
                size="lg"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e as any);
                }}
                style={{
                  backgroundColor: '#4CAF50',
                  borderColor: '#4CAF50',
                  fontWeight: '600',
                  padding: '12px 40px',
                  borderRadius: '25px'
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  'Gönder'
                )}
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </div>
  );
};

export default SosyalHizmetBirimiPage;
